import { v5 as uuidv5 } from 'uuid'

const NAMESPACE = 'b3f47405-db30-47ac-a00b-292e6decf14b'

export const getUniqueUserId = (projectName: string, userId: number) =>
  uuidv5(`${projectName}-${userId}`, NAMESPACE)

export default getUniqueUserId
